import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "safety",
  "use": "safety-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"safety\"><path d=\"m12 1.5-9 3v9a9 9 0 0 0 9 9 9 9 0 0 0 9-9v-9l-9-3Zm7.313 12a7.313 7.313 0 0 1-14.625 0V5.766L12 3.187l7.313 2.579V13.5Z\" /><path d=\"M8.87 11.135a.842.842 0 0 0-1.442.597.842.842 0 0 0 .248.596l3.033 3.033.05.05a.797.797 0 0 0 1.127 0l5.238-5.24a.797.797 0 0 0 0-1.126l-.066-.066a.797.797 0 0 0-1.127 0l-4.61 4.608-2.452-2.452Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol